import styled from 'styled-components';
import { FieldListProps } from '../types';
import { FieldRow } from './FieldRow';

export const FieldList = ({
  fields,
  mode,
  onEditField,
  onAcceptAiAnswer,
  onClearField,
  onOverrideAnswer,
  onRelinkField,
  showAcceptButton = true,
  showClearButton = true,
  showEditButton = true,
  customFieldRenderer,
  isDisabled = false
}: FieldListProps) => {
  return (
    <FieldListWrapper mode={mode}>
      {fields?.map((field, index) => (
        <FieldRow
          key={field.id}
          field={field}
          index={index}
          mode={mode}
          onEditField={onEditField}
          onAcceptAiAnswer={onAcceptAiAnswer}
          onClearField={onClearField}
          onOverrideAnswer={onOverrideAnswer}
          onRelinkField={onRelinkField}
          showAcceptButton={showAcceptButton}
          showClearButton={showClearButton}
          showEditButton={showEditButton}
          customFieldRenderer={customFieldRenderer}
          isDisabled={isDisabled}
        />
      ))}
    </FieldListWrapper>
  );
};

const FieldListWrapper = styled.div<{ mode: 'view' | 'edit' }>`
  display: flex;
  flex-direction: column;
  gap: ${({ mode }) => (mode === 'view' ? '30px' : '0px')};
`;
